import React, { useRef, useState, useEffect, useMemo } from "react";

import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import {
    Box,
    Tooltip
} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Stack from '@mui/material/Stack';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import UpcomingIcon from '@mui/icons-material/Upcoming';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Paper from '@mui/material/Paper';

import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ReactApexChart from 'react-apexcharts';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import moment from 'moment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';

import { parseISO } from 'date-fns';
import ScheduleIcon from '@mui/icons-material/Schedule';

import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';

import { Card, CardContent, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';

import { Button } from "@material-ui/core";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';




const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function Parcelas({ }) {




    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    const dataAtual = new Date();
    const mesAtual = dataAtual.toLocaleString('default', { month: 'long' });
    const anoAtual = dataAtual.getFullYear();

    const [totalRegistros, setTotalRegistros] = useState(0);

    const [filtro, setFiltro] = useState('');

    const [estatisticas, setEstatisticas] = useState({
        numDespesas: 0,
        numReceitas: 0,
        valorTotalDespesa: 0,
        valorTotalReceita: 0,
        valorTotalDespesaPaga: 0,
        valorTotalReceitaPaga: 0,
        valorTotalDespesaAPagar: 0,
        valorTotalReceitaAPagar: 0,
        valorTotalDespesaVencida: 0,
        valorTotalDespesaVenceHoje: 0,
        valorTotalDespesaAVencer: 0,
        valorTotalReceitaVencida: 0,
        valorTotalReceitaVenceHoje: 0,
        valorTotalReceitaAVencer: 0,
    });


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });



    const regras = Cookies.get("regra") || "";

    let tipo = null;

    if (regras.includes("ADMIN_CONTAS_A_PAGAR") && regras.includes("ADMIN_CONTAS_A_RECEBER")) {
        tipo = -1;
    } else if (regras.includes("ADMIN_CONTAS_A_PAGAR")) {
        tipo = 0;
    } else if (regras.includes("ADMIN_CONTAS_A_RECEBER")) {
        tipo = 1;
    }


    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 1000,
    });





    function calcularEstatisticas(filteredRows) {
        const hoje = moment(); // exatamente como no Footer

        const stats = filteredRows.reduce((acc, parcela) => {
            try {
                const valor = Number(parcela.valor) || 0;
                const dataVencimento = parcela.data_vencimento
                    ? moment(parcela.data_vencimento, "YYYY-MM-DD")
                    : null;

                if (!dataVencimento || !dataVencimento.isValid()) {
                    // data inválida, ignora vencimento
                }

                if (parcela.tipo_lancamento === 0) {
                    // Despesas
                    acc.numDespesas += 1;
                    acc.valorTotalDespesa += valor;
                    if (parcela.status === 1) acc.valorTotalDespesaPaga += valor;
                    if (parcela.status === 0) acc.valorTotalDespesaAPagar += valor;

                    console.log("data_vencimento: " + dataVencimento);
                    console.log("hoje: " + hoje);

                    if (parcela.status === 0) {
                        if (dataVencimento.isBefore(hoje, 'day')) {
                            console.log("vencido: " + valor);
                            acc.valorTotalDespesaVencida += valor;
                        } else if (dataVencimento.isSame(hoje, 'day')) {
                            console.log("vencido hoje: " + valor)
                            acc.valorTotalDespesaVenceHoje += valor;
                        } else {
                            console.log("vai vencer: " + valor)
                        }
                    }

                } else if (parcela.tipo_lancamento === 1) {
                    // Receitas
                    acc.numReceitas += 1;
                    acc.valorTotalReceita += valor;
                    if (parcela.status === 1) acc.valorTotalReceitaPaga += valor;
                    if (parcela.status === 0) acc.valorTotalReceitaAPagar += valor;


                    if (parcela.status === 0) {
                        if (dataVencimento.isBefore(hoje, 'day')) {
                            acc.valorTotalReceitaVencida += valor;
                        } else if (dataVencimento.isSame(hoje, 'day')) {
                            acc.valorTotalReceitaVenceHoje += valor;
                        }
                    }
                }
            } catch (error) {
                console.error("Erro ao calcular estatísticas para parcela:", parcela, error);
            }
            return acc;
        }, {
            numDespesas: 0,
            numReceitas: 0,
            valorTotalDespesa: 0,
            valorTotalReceita: 0,
            valorTotalDespesaPaga: 0,
            valorTotalReceitaPaga: 0,
            valorTotalDespesaAPagar: 0,
            valorTotalReceitaAPagar: 0,
            valorTotalDespesaVencida: 0,
            valorTotalDespesaVenceHoje: 0,
            valorTotalReceitaVencida: 0,
            valorTotalReceitaVenceHoje: 0,
        });

        stats.valorTotalDespesaAVencer =
            stats.valorTotalDespesaAPagar - (stats.valorTotalDespesaVencida + stats.valorTotalDespesaVenceHoje);

        stats.valorTotalReceitaAVencer =
            stats.valorTotalReceitaAPagar - (stats.valorTotalReceitaVencida + stats.valorTotalReceitaVenceHoje);

        // arredonda
        const rounded = Object.fromEntries(
            Object.entries(stats).map(([k, v]) =>
                k.startsWith('valor') ? [k, Math.round((v + Number.EPSILON) * 100) / 100] : [k, v]
            )
        );

        setEstatisticas(rounded);
    }


    async function listarParcelas() {

        setLoading(true);

        try {
            const token = Cookies.get('token');
            const id_usuario = Cookies.get('id_usuario');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const regra = Cookies.get('regra');
            if (regra.includes("ADMIN")) {



                let response2 = await api.get(`v1/protected/financeiro/parcelas/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}&tipo=${tipo}`, { headers });

                setObjetos(response2.data.dados); // você deve retornar os dados paginados como { dados: [...], total: X }


                calcularEstatisticas(response2.data.dados);
                setTotalRegistros(response2.data.total);
                setLoading(false);


            }

        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }






    useEffect(() => {
        listarParcelas();
    }, [pagination]); // <-- refaz a requisição ao mudar página ou tamanho




    const columns = useMemo(
        () => [

            {
                accessorKey: 'id_parcela',
                header: 'ID',
                size: 30,
                accessorFn: row => row.id_parcela, // garante que filtro funcione
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: 'tipo_lancamento',
                header: 'Tipo',
                size: 30,
                accessorFn: row => row.tipo_lancamento === 0 ? 'Despesa' : 'Receita', // usado para exibição e filtro
                Cell: ({ row }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {row.original.tipo_lancamento === 0 ? 'Despesa' : 'Receita'}
                    </span>
                ),
            },
            {
                header: 'Identificador',
                size: 150,
                accessorKey: 'identificador', // continua pegando identificador por padrão
                Cell: ({ row }) => {
                    const identificador = row.original.identificador;
                    const fallback = row.original.identificacao_lancamento;

                    // Checa se identificador é inválido (null, undefined, vazio ou só espaços)
                    const value = identificador && identificador.toString().trim() !== ''
                        ? identificador
                        : fallback || '-';

                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            🆔 {value}
                        </span>
                    );
                },
            },
            {
                header: 'Parcela',
                size: 50,
                accessorKey: 'parcela_numero', // continua pegando identificador por padrão
                Cell: ({ row }) => {

                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {row.original.parcela_numero}
                        </span>
                    );
                },
            },

            {
                header: 'Fornecedor',
                size: 300,
                maxHeight: 300,
                accessorKey: 'fornecedor', // usar accessorKey direto facilita filtros e ordenação
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <BusinessIcon fontSize="small" color="primary" />
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: 'valor',
                header: 'Valor',
                size: 200,
                Cell: ({ row }) => {
                    const valor = row.original.valor || 0;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <AttachMoneyIcon fontSize="small" color="primary" />
                                {currencyFormatter.format(valor)}
                            </span>
                        </div>
                    );
                },
                Footer: ({ table }) => {
                    const hoje = moment();
                    const rows = table.getFilteredRowModel().rows.map(r => r.original);

                    // 🔹 Função auxiliar para somar valores com condição
                    const soma = filtro => rows
                        .filter(filtro)
                        .reduce((acc, row) => acc + (row.valor || 0), 0);

                    // 🔹 Cálculos gerais
                    const total = soma(() => true);

                    // 🔹 Despesas
                    const despesaTotal = soma(r => r.tipo_lancamento === 0);
                    const despesaPaga = soma(r => r.tipo_lancamento === 0 && r.status === 1);
                    const despesaAPagar = soma(r => r.tipo_lancamento === 0 && r.status === 0);
                    const despesaVencida = soma(
                        r =>
                            r.tipo_lancamento === 0 &&
                            r.status === 0 &&
                            moment(r.data_vencimento, "YYYY-MM-DD").isBefore(hoje)
                    );
                    const despesaAVencer = soma(
                        r =>
                            r.tipo_lancamento === 0 &&
                            r.status === 0 &&
                            moment(r.data_vencimento, "YYYY-MM-DD").isAfter(hoje)
                    );

                    // 🔹 Receitas
                    const receitaTotal = soma(r => r.tipo_lancamento === 1);
                    const receitaPaga = soma(r => r.tipo_lancamento === 1 && r.status === 1);
                    const receitaAPagar = soma(r => r.tipo_lancamento === 1 && r.status === 0);
                    const receitaVencida = soma(
                        r =>
                            r.tipo_lancamento === 1 &&
                            r.status === 0 &&
                            moment(r.data_vencimento, "YYYY-MM-DD").isBefore(hoje)
                    );
                    const receitaAVencer = soma(
                        r =>
                            r.tipo_lancamento === 1 &&
                            r.status === 0 &&
                            moment(r.data_vencimento, "YYYY-MM-DD").isAfter(hoje)
                    );

                    return (
                        <div style={{ fontSize: 13, lineHeight: 1.6, display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <strong style={{ color: '#1976d2' }}>
                                Total: {currencyFormatter.format(total)}
                            </strong>

                            <div style={{ marginTop: 6 }}>
                                <strong style={{ color: '#d32f2f' }}>💸 Despesas</strong>
                                <div>• Total: {currencyFormatter.format(despesaTotal)}</div>
                                <div>• Pagas: {currencyFormatter.format(despesaPaga)}</div>
                                <div>• A Pagar: {currencyFormatter.format(despesaAPagar)}</div>
                                <div>• Vencidas: {currencyFormatter.format(despesaVencida)}</div>
                                <div>• A Vencer: {currencyFormatter.format(despesaAVencer)}</div>
                            </div>

                            <div style={{ marginTop: 8 }}>
                                <strong style={{ color: '#2e7d32' }}>💰 Receitas</strong>
                                <div>• Total: {currencyFormatter.format(receitaTotal)}</div>
                                <div>• Pagas: {currencyFormatter.format(receitaPaga)}</div>
                                <div>• A Receber: {currencyFormatter.format(receitaAPagar)}</div>
                                <div>• Vencidas: {currencyFormatter.format(receitaVencida)}</div>
                                <div>• A Vencer: {currencyFormatter.format(receitaAVencer)}</div>
                            </div>
                        </div>
                    );
                },
            },

            {
                accessorKey: 'status',
                header: 'Status',
                size: 130,
                accessorFn: row => {
                    if (row.status === 0) return 'NÃO PAGO';
                    if (row.status === 1) return 'PAGO';
                    return '';
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue(); // agora vem "NÃO PAGO" ou "PAGO"

                    if (value === 'NÃO PAGO')
                        return <><CancelIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'PAGO')
                        return <><CheckCircleIcon color="success" fontSize="small" /> {value}</>;

                    return null;
                },
            },

            {
                accessorKey: 'data_vencimento',
                header: 'Data Venc.',
                size: 120,
                Cell: ({ cell }) => {
                    const data = cell.getValue();
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <HourglassBottomIcon fontSize="small" color="action" />
                            {data ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY") : '-'}
                        </span>
                    );
                },
            },
            {
                header: 'Status Parc',
                accessorKey: 'status_parcela',
                size: 130,
                accessorFn: row => {
                    const hoje = moment(); // pega data e hora atual completas
                    const vencimento = moment(row.data_vencimento, "YYYY-MM-DD"); // ou ajuste formato se vier diferente

                    if (row.status === 1) return 'PAGO';

                    if (row.status === 0) {
                        if (vencimento.isBefore(hoje, 'day')) {
                            return 'VENCIDO';
                        } else if (vencimento.isSame(hoje, 'day')) {
                            return 'VENCE HOJE';
                        } else {
                            return 'A VENCER';
                        }
                    }

                    return '';
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue();

                    if (value === 'VENCIDO')
                        return <><CancelIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'A VENCER' || value === "VENCE HOJE")
                        return <><ScheduleIcon color="warning" fontSize="small" /> {value}</>;
                    if (value === 'PAGO')
                        return <><CheckCircleIcon color="success" fontSize="small" /> {value}</>;

                    return null;
                },
            },
            {
                accessorKey: 'metodo_pagamento',
                header: 'Método Pag.',
                size: 150,
                accessorFn: row => row.metodo_pagamento,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <AccountBalanceIcon fontSize="small" color="action" />
                        {renderedCellValue}
                    </span>
                ),
            },



        ].filter(Boolean),
        [],
    );


    async function exportar(idsSelecionados) {
        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            };

            // Faz a requisição para gerar o arquivo
            const response = await api.post(
                'v1/protected/financeiro/parcelas/exportar/' + Cookies.get("id_usuario"),
                idsSelecionados,
                { headers }
            );

            // A resposta do backend deve ser algo como:
            // "Exportação concluída! Arquivo gerado em: /home/wwgrup/parcelas/relatorio/relatorio_20251101_021000.xls"
            const message = response.data;

            if (message) {
                let filePath = message;

                // Substituir caminho local pelo link público
                filePath = filePath.replace('/home/wwgrup/relatorios', 'https://gruporosinetos.com/relatorios');

                // Abrir em nova aba
                window.open(filePath, '_blank');
            } else {
                console.error("Não foi possível extrair o caminho do arquivo da resposta do backend");
            }

        } catch (err) {
            console.error("Erro ao exportar: ", err);
        }
    }

    function handleClickGerenciar(row) {
        const idLancamento = row.original.id_lancamento;
        const url = `/gestao/financas/lancamento/gerenciar/${idLancamento}`;
        window.location.href = url;
    }

    const tableHeight = window.innerHeight - 200; // 300px é um exemplo do cabeçalho + filtros + padding


    const [columnFilters, setColumnFilters] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [submenuDespesa, setSubmenuDespesa] = useState(null);
    const [submenuReceita, setSubmenuReceita] = useState(null);
    const [submenuDespesaBoleto, setSubmenuDespesaBoleto] = useState(null);
    const [submenuDespesaPix, setSubmenuDespesaPix] = useState(null);
    const [submenuReceitaBoleto, setSubmenuReceitaBoleto] = useState(null);
    const [submenuReceitaPix, setSubmenuReceitaPix] = useState(null);


    // Estados
    const [submenuInfo, setSubmenuInfo] = useState({ tipo: null, metodo: null, anchor: null });

    // Função para abrir submenu
    const openSubmenu = (tipo, metodo, event) => {
        setSubmenuInfo({ tipo, metodo, anchor: event.currentTarget });
    };

    // Função para fechar submenu
    const closeSubmenu = () => {
        setSubmenuInfo({ tipo: null, metodo: null, anchor: null });
    };


    // 🔹 Controla delays para fechamento suave
    const closeTimers = useRef({});



    const aplicarFiltrosRapidos = (filtros) => {
        filtros.forEach((f) =>
            table.setColumnFilters((prev) => [
                ...prev.filter((x) => x.id !== f.id),
                { id: f.id, value: f.value },
            ])
        );
    };

    const table = useMaterialReactTable({
        columns,
        data: objetos,
        enableBottomToolbar: true,
        enableGlobalFilterModes: true,
        enableRowActions: true,
        enableRowSelection: true,
        manualPagination: true,
        onPaginationChange: setPagination,
        rowCount: totalRegistros,
        state: { pagination, columnFilters },
        onColumnFiltersChange: setColumnFilters,
        enableStickyHeader: true,
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_parcela,
        enableGrouping: true,
        initialState: {
            showGlobalFilter: true,
            showColumnFilters: true,
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: 'calc(100vh - 370px)',
                overflowY: 'auto',
            },
        },
        muiPaginationProps: {
            rowsPerPageOptions: [1000, 2000, 3000],
            variant: 'outlined',
        },
        enableFullScreenToggle: true,
        enableExpandAll: false,
        enableExpanding: false,

        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                <Tooltip title="Gerenciar">
                    <IconButton color="error" onClick={() => handleClickGerenciar(row)}>
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),

        muiTableHeadCellProps: { sx: { fontSize: '0.8rem', padding: '6px 8px' } },
        muiTableBodyCellProps: { sx: { fontSize: '0.75rem', padding: '2px 6px' } },
        muiTableBodyRowProps: { sx: { minHeight: '24px' } },
        localization: MRT_Localization_PT_BR,

        renderTopToolbarCustomActions: () => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {/* 🔹 Botão Exportar */}
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                        const selecionadas = table.getSelectedRowModel().rows.map(row => row.original.id_parcela);
                        exportar(selecionadas);
                    }}
                    sx={{ marginLeft: '1rem' }}
                >
                    Exportar
                </Button>

                <>
                    <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        startIcon={<MoreVertIcon />}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                        Filtros Rápidos
                    </Button>

                    {/* Menu principal */}
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                         <MenuItem
                            onClick={(e) => openSubmenu('DESPESA', '', e)}
                        >
                            💸 Despesas  <ArrowRightIcon />
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => openSubmenu('DESPESA', 'BOLETO', e)}
                        >
                            💸 Despesas - BOLETO <ArrowRightIcon />
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => openSubmenu('DESPESA', 'PIX', e)}
                        >
                            💸 Despesas - PIX <ArrowRightIcon />
                        </MenuItem>
                         <MenuItem
                            onClick={(e) => openSubmenu('RECEITA', '', e)}
                        >
                            💰 Receitas <ArrowRightIcon />
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => openSubmenu('RECEITA', 'BOLETO', e)}
                        >
                            💰 Receitas - BOLETO <ArrowRightIcon />
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => openSubmenu('RECEITA', 'PIX', e)}
                        >
                            💰 Receitas - PIX <ArrowRightIcon />
                        </MenuItem>

                        <MenuItem
                            onClick={() => setColumnFilters([])}
                            sx={{ color: 'error.main' }}
                        >
                            Limpar Filtros
                        </MenuItem>
                    </Menu>

                    {/* Submenu */}
                    <Menu
                        anchorEl={submenuInfo.anchor}
                        open={Boolean(submenuInfo.anchor)}
                        onClose={closeSubmenu}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    >
                        {['VENCIDO', 'A VENCER', 'VENCE HOJE'].map((status) => (
                            <MenuItem
                                key={status}
                                onClick={() => {
                                    aplicarFiltrosRapidos([
                                        { id: 'tipo_lancamento', value: submenuInfo.tipo },
                                        { id: 'metodo_pagamento', value: submenuInfo.metodo },
                                        { id: 'status_parcela', value: status },
                                    ]);
                                    closeSubmenu();
                                }}
                            >
                                {status}
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            </Box>
        ),
    });

    return (

        <div >
            <Box
                sx={{
                    mb: 3,
                    display: "flex",
                    flexDirection: "column",
                    pl: 2,
                    pr: 2,
                    gap: 2, // espaçamento entre título/botão e estatísticas
                }}
            >
                {/* Cabeçalho */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <ReceiptLongIcon color="primary" />
                        <Typography
                            variant="h6"
                            component="h1"
                            fontWeight="bold"
                            color="primary"
                        >
                            {"Parcelas"}
                        </Typography>


                    </Box>

                </Box>


                <Grid container spacing={1}>



                    <Grid item xs={6} container>


                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1}>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <MoneyOffIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        {estatisticas?.numDespesas || 0} Parcelas de Despesas
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <TrendingDownIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total: {currencyFormatter.format(estatisticas.valorTotalDespesa)}
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <CheckCircleIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total Pago: {currencyFormatter.format(estatisticas.valorTotalDespesaPaga)}
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <HourglassBottomIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total a Pagar: {currencyFormatter.format(estatisticas.valorTotalDespesaAPagar)}
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Grid>

                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1}>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <EventBusyIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vencido: {currencyFormatter.format(estatisticas.valorTotalDespesaVencida)}
                                    </Typography>
                                </Paper>

                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <EventAvailableIcon color="warning" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vencendo Hoje: {currencyFormatter.format(estatisticas.valorTotalDespesaVenceHoje)}
                                    </Typography>
                                </Paper>

                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <UpcomingIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vence Futuro: {currencyFormatter.format(estatisticas.valorTotalDespesaAVencer)}
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Grid>

                    </Grid>

                    <Grid item xs={6} container>

                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1}>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <AttachMoneyIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        {estatisticas?.numReceitas || 0} Parcelas de Receitas
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <TrendingUpIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total: {currencyFormatter.format(estatisticas.valorTotalReceita)}
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <CheckCircleIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total Recebido: {currencyFormatter.format(estatisticas.valorTotalReceitaPaga)}
                                    </Typography>
                                </Paper>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <HourglassBottomIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Total a Receber: {currencyFormatter.format(estatisticas.valorTotalReceitaAPagar)}
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Grid>

                        <Grid item xs={12}>
                            <Stack direction="row" spacing={1}>
                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <EventBusyIcon color="error" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vencido: {currencyFormatter.format(estatisticas.valorTotalReceitaVencida)}
                                    </Typography>
                                </Paper>

                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <EventAvailableIcon color="warning" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vencendo Hoje: {currencyFormatter.format(estatisticas.valorTotalReceitaVenceHoje)}
                                    </Typography>
                                </Paper>

                                <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                    <UpcomingIcon color="success" sx={{ fontSize: 14 }} />
                                    <Typography variant="caption" fontWeight="bold">
                                        Vence Futuro: {currencyFormatter.format(estatisticas.valorTotalReceitaAVencer)}
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Grid>

                    </Grid>

                </Grid>

            </Box>

            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <div>
                    <div style={{ backgroundColor: 'white', height: tableHeight }}>
                        {objetos !== null && (
                            <>

                                <MaterialReactTable table={table} />
                            </>
                        )}
                    </div>
                </div>
            }




        </div>


    );
}



